import _ from "lodash"
import { Language } from "@/types/language"

/**
 * Deliberately a leaf: no app imports. `internationalisation/index.ts` calls
 * `setupI18n()` while it is still being imported, and reaching this helper through
 * `helpers/common` pulled in the common -> router -> stores -> http-service -> common
 * cycle. Half-initialised, `common` had not exported it yet, so the call failed with
 * "getLanguageIsoCode is not a function" and took four unit suites with it.
 *
 * Not `helpers/language.ts` — that one imports `@/internationalisation` and would
 * close the same loop again.
 */
export function getLanguageIsoCode(language: Language) {
  return _.get(language, "translationCode.code", "")
}
